module.exports = __webpack_public_path__ + "img/symbol_3.bb436e64.png";